
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/classes/[slug]",
      function () {
        return require("private-next-pages/classes/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/classes/[slug]"])
      });
    }
  